import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';
import { ReportingGetClientPersonalDetailsRequest } from 'bff/client';

export const getPersonalDetails = (request: ReportingGetClientPersonalDetailsRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['PersonalDetails'],
    queryFn: () => reportingApi.reportingGetClientPersonalDetails(request),
    staleTime: 0,
    refetchOnMount: 'always',
    select: (response) => {
      const data = response.data;
      return data;
    }
  });
};
